import PubSub from "underpub-js";

var ButtonPlay = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-ButtonPlay',
	};

	$.extend(true, this.options, options);

};

ButtonPlay.prototype.init = function() {

	var self = this;

};

export default ButtonPlay;
